import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Logo } from '@morressier/alembic';
import {
  faEye,
  faGolfFlagHole,
  faSliders,
  faTelescope
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ClientBrand,
  useAuthRealm
} from 'src/routes/AuthRealmAccessControl/AuthRealmContext';
import { useNavigate } from 'react-router-dom';
import UnauthenticatedFooter from 'src/components/UnauthenticatedFooter';

const gridSection = [
  {
    name: 'Manage',
    icon: faSliders
  },
  {
    name: 'Explore',
    icon: faTelescope
  },
  {
    name: 'Visualize',
    icon: faEye
  },
  {
    name: 'Analyze',
    icon: faGolfFlagHole
  }
];

export const twoColumnBrandLayoutGeneric = (brandConfig: ClientBrand) => () => {
  const { authRealm, getLoginUrlForAuthRealm } = useAuthRealm();
  const navigate = useNavigate();

  const handleLogin = () => {
    window.location.href = getLoginUrlForAuthRealm(authRealm);
  };

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <Flex
      minHeight="100dvh"
      direction="column"
      overflow={{ base: 'visible', md: 'hidden' }}
    >
      <Flex
        width="full"
        flex="1"
        alignItems="center"
        justifyContent="center"
        overflowY={{ base: 'visible', md: 'auto' }}
        backgroundImage={brandConfig.loginBackgroundImage}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      >
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          width={{ base: '100%', lg: '65%' }}
          maxWidth={{ base: '100%', xl: '1100px' }}
          textAlign="center"
          gap={{ base: 4, md: 4 }}
          paddingX={{ base: 2, md: 20 }}
          paddingY={{ base: 2, md: 5 }}
        >
          <Logo
            src={brandConfig.logoUrl}
            alt={`${brandConfig.name} logo`}
            width={{ base: '140px', md: '173px' }}
          />

          <Box>
            <Text
              textStyle="headingTitle"
              fontSize={{ base: '2xl', md: '38px' }}
            >
              Journal Manager
            </Text>
          </Box>

          <Text textStyle="textBody" maxWidth={{ base: '100%', lg: '900px' }}>
            {brandConfig.description}
          </Text>
          {brandConfig.isIconRequired && (
            <Flex gap={{ base: 4, md: 6 }} wrap="wrap" justifyContent="center">
              {gridSection.map(section => (
                <Flex
                  gap={2}
                  key={section.name}
                  direction="column"
                  alignItems="center"
                >
                  <Flex
                    backgroundColor={
                      brandConfig.name === 'SCUP'
                        ? 'white'
                        : 'actionSecondaryFill'
                    }
                    width={{ base: 16, md: 20 }}
                    height={{ base: 16, md: 20 }}
                    borderRadius={90}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <FontAwesomeIcon icon={section.icon} size="xl" />
                  </Flex>
                  <Text textStyle="headingItem">{section.name}</Text>
                </Flex>
              ))}
            </Flex>
          )}

          <Flex
            gap={4}
            mt={{ base: 2, md: 4 }}
            mb={{ base: 8, md: 4 }}
            direction={{ base: 'column', sm: 'row' }}
            width={{ base: '100%', sm: 'auto' }}
          >
            <Button onClick={handleLogin} width={{ base: '100%', sm: 'auto' }}>
              Sign In
            </Button>
            <Button
              variant="secondary"
              style={{ border: '1px solid' }}
              onClick={handleSignUp}
              width={{ base: '100%', sm: 'auto' }}
            >
              Sign Up
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Box flexShrink={0}>
        <UnauthenticatedFooter />
      </Box>
    </Flex>
  );
};
